import React, { useState } from "react";
import { TextField, IconButton, InputAdornment, Typography, Box } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { C } from "../constants/colors";
import { passwordChecks, fieldTone, textFieldToneSx } from "../utils/passwordRules";

export function PasswordRulesList({ password }) {
  const checks = passwordChecks(password);
  return (
    <Box sx={{ display: "grid", gap: 0.5, mt: 0.75, mb: 0.5 }}>
      {checks.map((c) => (
        <Box key={c.id} sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: 12.5, color: c.ok ? C.success : C.muted, fontWeight: 500 }}>
          {c.ok
            ? <CheckCircleOutlineIcon sx={{ fontSize: 16 }} />
            : <HighlightOffIcon sx={{ fontSize: 16 }} />}
          {c.label}
        </Box>
      ))}
    </Box>
  );
}

export default function PasswordField({
  label = "Password",
  value,
  onChange,
  autoComplete = "current-password",
  placeholder = "••••••••",
  tone = "idle",
  showRules = false,
  helperText = "",
  name,
}) {
  const [show, setShow] = useState(false);
  return (
    <Box sx={{ mb: 1.75 }}>
      {label && (
        <Typography sx={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", mb: 0.7 }}>{label}</Typography>
      )}
      <TextField
        fullWidth
        name={name}
        type={show ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        sx={textFieldToneSx(tone, C)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                type="button"
                aria-label={show ? "Hide password" : "Show password"}
                onClick={() => setShow((s) => !s)}
                edge="end"
                size="small"
              >
                {show
                  ? <VisibilityOffOutlinedIcon sx={{ fontSize: 20, color: C.muted }} />
                  : <VisibilityOutlinedIcon sx={{ fontSize: 20, color: C.muted }} />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {showRules && <PasswordRulesList password={value} />}
      {helperText ? (
        <Typography sx={{ fontSize: 12, fontWeight: 500, mt: 0.6, color: tone === "bad" ? C.error : tone === "ok" ? C.success : C.muted }}>
          {helperText}
        </Typography>
      ) : null}
    </Box>
  );
}

export { fieldTone };
